import { EventBookingStatus, EventSystemStatus, ISummaryCalendlyEvent } from 'types';

export const getActiveScheduledInterviews = (calendlyInterviews: ISummaryCalendlyEvent[]): ISummaryCalendlyEvent[] => {
  return calendlyInterviews.filter(
    (interview: ISummaryCalendlyEvent) =>
      interview.bookingStatus !== EventBookingStatus.CANCELED &&
      interview.systemStatus !== EventSystemStatus.DELETED &&
      interview.systemStatus !== EventSystemStatus.FAILED,
  );
};
